import requests from '@/utils/requests';

/**
 * 测试计划列表接口
 * @param {*} data
 */
export function testPlanList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/list',
    method: 'post',
    data
  });
}

/**
 * 添加测试计划接口
 * @param {*} data
 */
export function testPlanAdd(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/add',
    method: 'post',
    data
  });
}

/**
 * 删除测试计划接口
 * @param {*} data
 */
export function testPlanDelete(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/delete',
    method: 'post',
    data
  });
}

/**
 * 复制测试计划接口
 * @param {*} data
 */
export function testPlanCopy(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/copy',
    method: 'post',
    data
  });
}

/**
 * 复制测试计划接口
 * @param {*} data
 */
export function testPlanLock(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/lockTestCase',
    method: 'post',
    data
  });
}

/**
 * 测试计划更新接口
 * @param {*} data
 */
export function testPlanUpdate(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/update',
    method: 'post',
    data
  });
}

/**
 * 测试计划更新某字段接口
 * @param {*} data
 */
export function testPlanUpdateItem(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/update/item',
    method: 'post',
    data
  });
}

/**
 * 测试计划状态更新接口
 * @param {*} data
 */
export function testPlanUpdateStatus(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/update/status',
    method: 'post',
    data
  });
}

/**
 * 测试计划详情接口
 * @param {*} data
 */
export function testPlanDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/detail',
    method: 'post',
    data
  });
}

/**
 * 测试计划获取变更记录接口
 * @param {*} data
 */
export function testPlanRecord(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/record',
    method: 'post',
    data
  });
}

/**
 * 测试计划获取变更记录接口
 * @param {*} data
 */
export function testCaseList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/caseList',
    method: 'post',
    data
  });
}

/**
 * 测试计划关联测试用例接口
 * @param {*} data
 */
export function bindTestCases(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/bindCases',
    method: 'post',
    data
  });
}

/**
 * 获取测试计划关联测试用例ID接口
 * @param {*} data
 */
export function planBindCaseIds(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/caseIds',
    method: 'post',
    data
  });
}

/**
 * 获取测试计划关联测试用例详情接口
 * @param {*} data
 */
export function planRelatedCases(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/relatedCases',
    method: 'post',
    data
  });
}

/**
 * 更新测试结果接口
 * @param {*} data
 */
export function updateTestCaseResult(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/caseResult',
    method: 'post',
    data
  });
}

/**
 * 用例详情接口
 * @param {*} data
 */
export function planCaseDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/caseDetail',
    method: 'post',
    data
  });
}

/**
 * 批量分配测试用例接口
 * @param {*} data
 */
export function assignTestcases(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/assign',
    method: 'post',
    data
  });
}

/**
 * 用例关联已有缺陷接口
 * @param {*} data
 */
export function bindIssues(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/bindIssues',
    method: 'post',
    data
  });
}

/**
 * 用例解绑缺陷接口
 * @param {*} data
 */
export function unbindIssue(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/unbindIssue',
    method: 'post',
    data
  });
}

/**
 * 用例缺陷Id列表接口
 * @param {*} data
 */
export function getCaseIssues(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/caseIssues',
    method: 'post',
    data
  });
}

/**
 *  根据PlanId获取缺陷分布信息
 * @param {*} data
 */
export function bugStats(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/bugDistribution',
    method: 'post',
    data
  });
}

export function getTestSuit(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testPlan/queryTestTasks',
    method: 'post',
    data
  });
}
